import React from "react";
import PropTypes from "prop-types";
import s from "./Button.module.css"; // Подключение CSS файла для стилей

const Button = ({
  label,
  onClick,
  type = "button",
  style,
  disabled = false,
}) => {
  return (
    <button
      className={s.custombutton}
      onClick={onClick}
      type={type}
      style={style}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired, // Текст кнопки
  onClick: PropTypes.func, // Обработчик события клика
  type: PropTypes.oneOf(["button", "submit", "reset"]), // Тип кнопки
  style: PropTypes.object, // Дополнительные стили
  disabled: PropTypes.bool, // Состояние блокировки кнопки
};

// Button.defaultProps = {
//   onClick: () => {}, // По умолчанию обработчик пустой
//   type: "button",
//   style: {},
//   disabled: false,
// };

export default Button;
